import { observable } from "mobx";

const store = observable({
  // address verification flow
  addrVer: {
    account: "",
    address: "",
    sig: "",
    sigId: "",
    aoppUrl: "",
  },

  // app data
  manualSigning: false,

  // user data
  user: {
    id: "",
    payRef: "",
    xtag: "",
    email: "",
  },

  // price websocket data
  websocket: {
    CHFBTCPrice: 0,
    EURBTCPrice: 0,
    GBPBTCPrice: 0,
    USDBTCPrice: 0,
    CHFsatsValue: 0,
    EURsatsValue: 0,
    GBPsatsValue: 0,
    USDsatsValue: 0,
  },

  // historical data
  historicalPrices: [],
  seriesDays: "182",

  // temp
  // registration
  acceptTerms: false,
  referrerXtag: "",
  // set xtag
  acceptAffiliateTerms: false,

  // orders store
  orders: [],
  firstOrderDate: "",
  displayCurrency: "EUR",
  priceChange24hr: 0,
  percentageChange24hr: 0,
  price: 0,
  satsValue: 0,

  // stacking metrics
  lastMonthSatsStacked: 0,
  lastMonthPaymentsTotal: 0,
  totalSatsStacked: 0,
  paymentsTotal: 0,
  totalAffiliatesDiscount: 0,
  totalProfitLossCHF: 0,
});

export default store;
